// extracted by mini-css-extract-plugin
export default {"buttonConfirm":"ButtonConfirmLogout_buttonConfirm__5j5qc"};